module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_12-f67f7da32b397edb6d9bf5505c85b078.png";